module.exports = __webpack_public_path__ + "img/ampel_grau.05331b10.svg";